import { getCompetentNLEducationApiCall, getCompetentNLEducationsApiCall } from '../../models/@competentNL/Educations/EducationsService';
import { transformToEducation } from '../../models/@competentNL/Educations/EducationsTransformers';
import { getCompetentNLOccupationApiCall, getCompetentNLOccupationsApiCall } from '../../models/@competentNL/Occupations/OccupationsService';
import { transformToOccupation } from '../../models/@competentNL/Occupations/OccupationsTransformers';
import { getCompetentNLSkillApiCall, getCompetentNLSkillsApiCall } from '../../models/@competentNL/Skills/SkillsService';
import { transformToSkill, transformToSkillBase } from '../../models/@competentNL/Skills/SkillsTransformers';
import { isFetchResultSuccessful } from '../../models/FetchResult';
import { TypedDispatch } from '../store';
import {
    setEducation,
    setEducations,
    setEducationsError,
    setEducationsIsLoading,
    setError,
    setIsLoading,
    setOccupation,
    setOccupations,
    setOccupationsError,
    setOccupationsIsLoading,
    setSkill,
    setSkillBases,
    setSkillsError,
    setSkillsIsLoading,
} from './competentNL';

export const fetchCompetentNLOccupations = (query: string) => async (dispatch: TypedDispatch): Promise<void> => {
    dispatch(setIsLoading(true));
    dispatch(setOccupationsIsLoading(true));
    dispatch(setOccupationsError(''));

    try {
        const competentNLOccupationsResponse = await getCompetentNLOccupationsApiCall(query);

        if (!isFetchResultSuccessful(competentNLOccupationsResponse)) {
            dispatch(setError(competentNLOccupationsResponse.error));
            return;
        }

        const occupations = competentNLOccupationsResponse.data.map(transformToOccupation);

        dispatch(setOccupations(occupations));
    } catch (error) {
        console.error('[fetchCompetentNLOccupations]', error);
        dispatch(setOccupationsError(error as string));
    } finally {
        dispatch(setIsLoading(false));
        dispatch(setOccupationsIsLoading(false));
    }
};

export const fetchCompetentNLOccupation = (id: string) => async (dispatch: TypedDispatch): Promise<void> => {
    dispatch(setIsLoading(true));
    dispatch(setOccupationsIsLoading(true));
    dispatch(setOccupationsError(''));
    dispatch(setOccupation(undefined));

    try {
        const competentNLOccupationResponse = await getCompetentNLOccupationApiCall(id);

        if (!isFetchResultSuccessful(competentNLOccupationResponse)) {
            dispatch(setError(competentNLOccupationResponse.error));
            return;
        }

        const occupation = competentNLOccupationResponse.data
            ? transformToOccupation(competentNLOccupationResponse.data)
            : undefined;

        dispatch(setOccupation(occupation));
    } catch (error) {
        console.error('[fetchCompetentNLOccupation]', error);
        dispatch(setOccupationsError(error as string));
    } finally {
        dispatch(setIsLoading(false));
        dispatch(setOccupationsIsLoading(false));
    }
};

export const fetchCompetentNLEducations = (query: string) => async (dispatch: TypedDispatch): Promise<void> => {
    dispatch(setIsLoading(true));
    dispatch(setEducationsIsLoading(true));
    dispatch(setEducationsError(''));

    try {
        const competentNLEducationsResponse = await getCompetentNLEducationsApiCall(query);

        if (!isFetchResultSuccessful(competentNLEducationsResponse)) {
            dispatch(setError(competentNLEducationsResponse.error));
            return;
        }

        const educations = competentNLEducationsResponse.data.map(transformToEducation);

        dispatch(setEducations(educations));
    } catch (error) {
        console.error('[fetchCompetentNLEducations]', error);
        dispatch(setEducationsError(error as string));
    } finally {
        dispatch(setIsLoading(false));
        dispatch(setEducationsIsLoading(false));
    }
};

export const fetchCompetentNLEducation = (id: string) => async (dispatch: TypedDispatch): Promise<void> => {
    dispatch(setIsLoading(true));
    dispatch(setEducationsIsLoading(true));
    dispatch(setEducationsError(''));
    dispatch(setEducation(undefined));

    try {
        const competentNLEducationResponse = await getCompetentNLEducationApiCall(id);

        if (!isFetchResultSuccessful(competentNLEducationResponse)) {
            dispatch(setError(competentNLEducationResponse.error));
            return;
        }

        const education = competentNLEducationResponse.data
            ? transformToEducation(competentNLEducationResponse.data)
            : undefined;

        dispatch(setEducation(education));
    } catch (error) {
        console.error('[fetchCompetentNLEducation]', error);
        dispatch(setEducationsError(error as string));
    } finally {
        dispatch(setIsLoading(false));
        dispatch(setEducationsIsLoading(false));
    }
};

export const fetchCompetentNLSkills = (query: string) => async (dispatch: TypedDispatch): Promise<void> => {
    dispatch(setIsLoading(true));
    dispatch(setSkillsIsLoading(true));
    dispatch(setSkillsError(''));
    dispatch(setSkillBases([]));

    try {
        const competentNLSkillsResponse = await getCompetentNLSkillsApiCall(query);

        if (!isFetchResultSuccessful(competentNLSkillsResponse)) {
            dispatch(setError(competentNLSkillsResponse.error));
            return;
        }

        const skillBases = competentNLSkillsResponse.data.map(transformToSkillBase);

        dispatch(setSkillBases(skillBases));
    } catch (error) {
        console.error('[fetchCompetentNLSkills]', error);
        dispatch(setSkillsError(error as string));
    } finally {
        dispatch(setIsLoading(false));
        dispatch(setSkillsIsLoading(false));
    }
};

export const fetchCompetentNLSkill = (id: string) => async (dispatch: TypedDispatch): Promise<void> => {
    dispatch(setIsLoading(true));
    dispatch(setSkillsIsLoading(true));
    dispatch(setSkillsError(''));
    dispatch(setSkill(undefined));

    try {
        const competentNLSkillResponse = await getCompetentNLSkillApiCall(id);

        if (!isFetchResultSuccessful(competentNLSkillResponse)) {
            dispatch(setError(competentNLSkillResponse.error));
            return;
        }

        const skill = competentNLSkillResponse.data
            ? transformToSkill(competentNLSkillResponse.data)
            : undefined;

        dispatch(setSkill(skill));
    } catch (error) {
        console.error('[fetchCompetentNLSkill]', error);
        dispatch(setSkillsError(error as string));
    } finally {
        dispatch(setIsLoading(false));
        dispatch(setSkillsIsLoading(false));
    }
};
